import { render, staticRenderFns } from "./ListSignersForTracking.vue?vue&type=template&id=83b052fa&"
import script from "./ListSignersForTracking.vue?vue&type=script&lang=js&"
export * from "./ListSignersForTracking.vue?vue&type=script&lang=js&"
import style0 from "./ListSignersForTracking.vue?vue&type=style&index=0&id=83b052fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports